import React from 'react'
import Proptypes from 'prop-types'
import { styled } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { saveDocumentToFile, buildReport } from '../../../../lib/report'
import Button from '@mui/material/Button'
import PrintIcon from '@mui/icons-material/Print'

const PrintIconStyled = styled(PrintIcon)({
  [`&.MuiSvgIcon-root`]: {
    color: '#333',
    background: 'white',
  },
})

export default function Report(props) {
  const { map } = props
  const { attacks, selectedAttack, selectedScenarioId } = useSelector(
    state => state
  )

  const click = event => {
    event.preventDefault()
    // eslint-disable-next-line no-undef
    var img = new Image()
    img.src = map.getCanvas().toBlob(mapBlob => {
      let report = buildReport(
        mapBlob,
        attacks,
        selectedAttack,
        selectedScenarioId
      )
      saveDocumentToFile(report, 'vda_report.docx')
    })
  }

  return (
    <Button className="layer-icon" style={{ right: '10px' }} onClick={click}>
      <PrintIconStyled />
    </Button>
  )
}
Report.propTypes = {
  map: Proptypes.object,
}
